import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { S1ZipService } from "../../services/s1-zip.service";
import { NgSelectComponent } from "@ng-select/ng-select";
import { IS1Response } from "@app/s1/services/s1-http-client.service";
import { TranslatorService } from "@app/core/translator/translator.service";
import swal2 from 'sweetalert2';

@Component({
  selector: "s1-zip-selection",
  templateUrl: "./s1-zip-selection.component.html",
  styleUrls: ["./s1-zip-selection.component.scss"],
  standalone: false
})
export class S1ZipSelectionComponent {

  @ViewChild('select') select: NgSelectComponent;

  @Output() zipCodeSelected: EventEmitter<string> = new EventEmitter<string>();

  zipCodes: { id: string, name: string }[] = [];

  constructor(
    private capService: S1ZipService,
    private translate: TranslateService,
    private translator: TranslatorService
  ) { }

  searchZipCodes(zip: string): void {
    if (zip && zip.length >= 3) {
      this.capService.getZipCodes(zip).subscribe({
        next: response => {
          this.fillZipCodesList(response);
        },
        error: _ => {
          swal2.fire('Errore', this.translate.instant('passengers.lbl_zip_error'), 'error');
        }
      });
    } else {
      this.clearZipCodes();
    }
  }

  manageZipCodeSelection(zip: string): void {
    this.select.blur();
    this.zipCodeSelected.emit(zip);
  }

  clearZipCodes(): void {
    this.zipCodes = [];
  }

  // -------- PRIVATE METHODS -------- //
  
  private fillZipCodesList(zipList: IS1Response): void {
    this.zipCodes = zipList.results.map(zip => ({
      id: zip.zip,
      name: `${zip.zip} - ${zip.name[this.translator.getLanguageInUse()]} (${zip.province})`
    }));
  }
  
}
